import MenuItem from "../models/class/menuItem/menuItem";

export default class MenuItemsUc {
  constructor(repository) {
    this.repository = repository
  }

  async allMenuItemsUc(cityId, userId) {
    try {
      const response = await this.repository.getAllMenuItems(cityId, userId)

      return {status: response.status, menus: response.data.map(MenuItem.fromJSONResponse)}
    } catch (error) {
      console.error(`error: ${error}`)
      if (error.response) {
        return {status: error.response.status, menus: []}
      } else {
        return {status: 500, menus: []}
      }
    }
  }
}
